import { render, staticRenderFns } from "./FacilityPermissionsForm.vue?vue&type=template&id=4317c10d&scoped=true"
import script from "./FacilityPermissionsForm.vue?vue&type=script&lang=js"
export * from "./FacilityPermissionsForm.vue?vue&type=script&lang=js"
import style0 from "./FacilityPermissionsForm.vue?vue&type=style&index=0&id=4317c10d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4317c10d",
  null
  
)

export default component.exports